<template>
    <div>
        <!-- Pulsanti visibili -->
        <template v-for="(button, b) in visibleButtons">

                <!-- Pulsante elimina per azioni visibili -->
                <v-tooltip top v-if="button.type === 'delete' && !noDelete" :key="b">
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            v-on="{ ...tooltip }"
                            @click="setConfirm(99, true)"
                            icon>
                            <v-icon color="error">{{ button.icon || 'mdi-trash-can-outline' }}</v-icon>
                        </v-btn>                    
                    </template>
                    <span>{{ button.tooltip || 'Elimina' }}</span>
                    <v-dialog v-model="confirm[99]" max-width="600" persistent>
                        <v-card class="background-2 round-card">
                            <v-card-title primary-title class="subtitle-1 background-2">{{ button.mainTitle || 'Vuoi Eliminare questo elemento?' }}</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text style="min-height: 100px;" class="pt-4 body-2">
                                {{ button.secondTitle || 'L\'elemento sarà eliminato solamente se indipendente e non collegato a nessun altra entità. Una volta eliminato non sarà possibile ripristinarlo' }}
                            </v-card-text>
                            <slot></slot>
                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click.native.stop="setConfirm(99, false)">Annulla</v-btn>
                                <v-btn :loading="loading[99]" text color="info" @click.native.stop="deleteModel()">Procedi</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-tooltip>

                <v-tooltip top v-else-if="button.type === 'redirect'" :key="b">
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            :disabled="checkDisabled(button)"
                            v-on="{ ...tooltip }"
                            @click="setConfirm(b, true)"
                            icon>
                            <v-icon>{{ button.icon }}</v-icon>
                        </v-btn>                    
                    </template>
                    <span>{{ button.tooltip }}</span>
                    <v-dialog v-model="confirm[b]" max-width="600" persistent :key="b">
                        <v-card class="background-2 round-card">
                            <v-card-title primary-title class="subtitle-1 background-2">{{ button.mainTitle }}</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text style="min-height: 100px;" class="pt-4 body-2">{{ button.secondTitle }}</v-card-text>
                            <slot></slot>
                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click.native.stop="setConfirm(b, false)">Annulla</v-btn>
                                <v-btn :loading="loading[b]" text color="info" @click.native.stop="apiActionRedirect(button, b)">Procedi</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-tooltip>

                <v-tooltip top v-else-if="button.type === 'goTo'" :key="b">
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            :disabled="checkDisabled(button)"
                            v-on="{ ...tooltip }"
                            @click="$eventBusUtility.goTo($router, button.route, id, createParams(button.params), {}, button.query_params || {})"
                            icon>
                            <v-icon>{{ button.icon }}</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ button.tooltip }}</span>
                </v-tooltip>

                <v-tooltip top v-else-if="button.type === 'print'" :key="b">
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn 
                            :disabled="checkDisabled(button)"
                            v-on="{ ...tooltip }"
                            @click="$eventBusUtility.openFile($store, '/' + button.url + '/' + id + '/print' + (button.params ? button.params : ''), $trans(info.model_name) + ' - ' + model.number) + (button.file_ext ? '.' + button.file_ext : '.pdf')"
                            icon>
                            <v-icon>{{ button.icon }}</v-icon>
                        </v-btn>                    
                    </template>
                    <span>{{ button.tooltip }}</span>
                </v-tooltip>

                <v-tooltip top v-else-if="button.type === 'download'" :key="b">
                    <template v-slot:activator="{ on: tooltip }">
                        <template v-if="button.settings_permission">
                            <v-btn v-if="button.settings_value ? $store.getters.getSetting(button.settings_permission) == button.settings_value : $store.getters.checkSettings(button.settings_permission)"
                                :disabled="checkDisabled(button)"
                                v-on="{ ...tooltip }"
                                @click="$eventBusUtility.openFile($store, generateUrl(button), $trans(info.model_name) + '.' + button.ext)"
                                icon>
                                <v-icon>{{ button.icon }}</v-icon>
                            </v-btn>
                        </template>
                        <v-btn v-else
                            :disabled="checkDisabled(button)"
                            v-on="{ ...tooltip }"
                            @click="$eventBusUtility.openFile($store, generateUrl(button), $trans(info.model_name) + '.' + button.ext)"
                            icon>
                            <v-icon>{{ button.icon }}</v-icon>
                        </v-btn>                    
                    </template>
                    <span>{{ button.tooltip }}</span>
                </v-tooltip>

                <template v-else-if="button.type === 'create-dialog'">
                    <create-dialog-button :key="b"
                        :button="button"
                        :model-def="button.modelDef"
                        :default-input="createParams(button.params)"
                        :icon="button.icon"
                        :tooltip-text="button.tooltip"
                        :dialog-title="button.dialogTitle"
                        :button-color="button.buttonColor"
                        :redirect="{'dialog': true}"
                        small
                    ></create-dialog-button>
                </template>

                <template v-else-if="button.type === 'component'">
                    <component 
                        :key="b"
                        :is="button.component"
                        :disabled="checkDisabled(button)"
                        :button="button"
                        :model="model"
                        :info="info"
                        :model-def="modelDef"
                        :params="button.params"
                        :id="id">
                    </component>
                </template>
        </template>

        <!-- Mostra il dropdown menu solo se ci sono azioni nel dropdown -->
        <v-menu
            v-if="dropdownButtons.length > 0"
            v-model="showButtonsList" 
            transition="slide-y-transition"
            content-class="round-card"
            :close-on-click="true"
            offset-y 
            min-width="200" 
            nudge-left="50">
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>

            <v-list dense>
                <v-subheader class="pt-2 fs12i" style="height:38px">Azioni</v-subheader>

                <!-- Dropdown buttons -->
                <template v-for="(button, b) in dropdownButtons">
                        
                        <!-- Pulsante elimina per azioni dropdown -->
                        <v-dialog v-if="button.type === 'delete' && !noDelete" :key="b" v-model="confirm[99]" max-width="600" persistent>
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item
                                    ripple
                                    @click="setConfirm(99, true)"
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                    <v-list-item-icon>
                                        <v-icon style="font-size: 18px;" class="red--text">{{ button.icon || 'mdi-trash-can-outline' }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="red--text">{{ button.tooltip || 'Elimina' }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>

                            <v-card class="background-2 round-card">
                                <v-card-title primary-title class="subtitle-1 background-2">{{ button.mainTitle || 'Vuoi Eliminare questo elemento?' }}</v-card-title>
                                <v-divider></v-divider>
                                <v-card-text style="min-height: 100px;" class="pt-4 body-2">
                                    {{ button.secondTitle || 'L\'elemento sarà eliminato solamente se indipendente e non collegato a nessun altra entità. Una volta eliminato non sarà possibile ripristinarlo' }}
                                </v-card-text>
                                <slot></slot>
                                <v-divider></v-divider>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click.native.stop="setConfirm(99, false)">Annulla</v-btn>
                                    <v-btn :loading="loading[99]" text color="info" @click.native.stop="deleteModel()">Procedi</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <v-dialog v-else-if="button.type === 'redirect'" :key="b" v-model="confirm[b]" max-width="600" persistent>
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item
                                    ripple
                                    @click="setConfirm(b, true)"
                                    :disabled="checkDisabled(button)"
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                    <v-list-item-icon>
                                        <v-icon style="font-size: 18px">{{ button.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ button.tooltip }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>

                            <v-card class="background-2 round-card">
                                <v-card-title primary-title class="subtitle-1 background-2">{{ button.mainTitle }}</v-card-title>
                                <v-divider></v-divider>
                                <v-card-text style="min-height: 100px;" class="pt-4 body-2">{{ button.secondTitle }}</v-card-text>
                                <slot></slot>
                                <v-divider></v-divider>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click.native.stop="setConfirm(b, false)">Annulla</v-btn>
                                    <v-btn :loading="loading[b]" text color="info" @click.native.stop="apiActionRedirect(button, b)">Procedi</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <v-list-item v-else-if="button.type === 'goTo'"
                            :key="b"
                            ripple
                            @click="$eventBusUtility.goTo($router, button.route, id, createParams(button.params), {}, button.query_params || {})"
                            :disabled="checkDisabled(button)"
                            >
                            <v-list-item-icon>
                                <v-icon style="font-size: 18px">{{ button.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ button.tooltip }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        
                        <v-list-item v-else-if="button.type === 'multiple_edit'" 
                            :key="b"
                            ripple
                            @click="multipleEdit(button, b)"
                            :disabled="checkDisabled(button)"
                            >
                            <v-list-item-icon>
                                <v-icon style="font-size: 18px">{{ button.icon ? button.icon : 'edit' }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ button.tooltip ? button.tooltip : 'Modifica multipla'}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-else-if="button.type === 'print'"
                            :key="b"
                            ripple
                            @click="$eventBusUtility.openFile($store, '/' + button.url + '/' + id + '/print' + (button.params ? button.params : ''), $trans(info.model_name) + ' - ' + model.number) + (button.file_ext ? '.' + button.file_ext : '.pdf')"
                            :disabled="checkDisabled(button)"
                            >
                            <v-list-item-icon>
                                <v-icon style="font-size: 18px">{{ button.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ button.tooltip }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <template v-else-if="button.type === 'download'">
                            <template v-if="button.settings_permission">
                                <v-list-item v-if="button.settings_value ? $store.getters.getSetting(button.settings_permission) == button.settings_value : $store.getters.checkSettings(button.settings_permission)"
                                    :key="b" 
                                    ripple
                                    @click="$eventBusUtility.openFile($store, generateUrl(button), $trans(info.model_name) + '.' + button.ext)"
                                    :disabled="checkDisabled(button)"
                                    >
                                    <v-list-item-icon>
                                        <v-icon style="font-size: 18px">{{ button.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ button.tooltip }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                            <template v-else>
                                <v-list-item
                                    :key="b"
                                    ripple
                                    @click="$eventBusUtility.openFile($store, generateUrl(button), $trans(info.model_name) + '.' + button.ext)"
                                    :disabled="checkDisabled(button)"
                                    >
                                    <v-list-item-icon>
                                        <v-icon style="font-size: 18px">{{ button.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ button.tooltip }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </template>

                        <template v-else-if="button.type === 'create-dialog'">
                            <create-dialog-button :key="b"
                                :button="button"
                                :model-def="button.modelDef"
                                :default-input="createParams(button.params)"
                                :icon="button.icon"
                                :tooltip-text="button.tooltip"
                                :dialog-title="button.dialogTitle"
                                :button-color="button.buttonColor"
                                button-component="v-list-item"
                                :redirect="{'dialog': true}"
                                small
                            ></create-dialog-button>
                        </template>

                        <template v-else-if="button.type === 'component'">
                            <component 
                                :key="b"
                                :is="button.component"
                                button-component="v-list-item"
                                :disabled="checkDisabled(button)"
                                :button="button"
                                :model="model"
                                :model-def="modelDef"
                                :params="button.params"
                                :id="id">
                            </component>
                        </template>
                </template>
            </v-list>
        </v-menu>

        <!-- Multiple edit dialog -->
        <v-dialog v-model="multipleEditDialog"
            max-width="870px"
            persistent
			scrollable
            :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">{{ titleDialog }}</p>
                    <v-spacer></v-spacer>
                </v-card-title>   
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                    <v-container>
                        <fields-generator class="mt-4"
                            :fieldsset.sync="fieldsset"
                            :model="multipleEditModel"
                            ref="fieldsgenerator"
							:multiple-edit="true"
						></fields-generator>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions class="px-2">
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native.stop="closeDialog()">Chiudi</v-btn>
                    <v-btn color="primary" text :loading="saved" @click.native="saveModel()">{{ 'Salva' }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
	</div>
</template>

<script>
    import Vue from 'vue'
    import SignatureDialog from '@/components/common/SignatureDialog'
    import StartCallButton from '@/components/common/StartCallButton'
    import UploadFileButton from '@/components/common/UploadFileButton'
    import PdfPreviewDialog from '@/components/common/PdfPreviewDialog'
    import GenerateBarcodeDialog from '@/components/common/GenerateBarcodeDialog'
    import ConvertLeadComponent from '@/components/modules/crm/ConvertLeadComponent'
    import TimecardButtonComponent from '@/components/common/TimecardButtonComponent'
    import ConvertProspectComponent from '@/components/modules/crm/ConvertProspectComponent'
    import GenerateOpportunityButton from '@/components/modules/tickets/GenerateOpportunityButton'
    import GenerateTroubleButtonComponent from '@/components/common/GenerateTroubleButtonComponent'
    import DuplicateProjectComponent from '@/components/modules/projects/DuplicateProjectComponent'
    import GenerateInterventionButton from '@/components/modules/tickets/GenerateInterventionButton'
    import GenerateConfigurationButton from '@/components/modules/mikrotik/GenerateConfigurationButton'
    import ConvertLeadToProspectComponent from '@/components/modules/crm/ConvertLeadToProspectComponent'
    import ConvertOpportunityToProjectComponent from '@/components/modules/opportunities/ConvertOpportunityToProjectComponent'
    import ProductStockAdjustmentDialog from '@/components/modules/products/ProductStockAdjustmentDialog'
    import GenerateSubscriptionDialog from '@/components/common/GenerateSubscriptionDialog'
    import ConvertToContractsDialog from '@/components/common/ConvertToContractsDialog'
    import GenerateSaleorderButton from '@/components/modules/quotations/GenerateSaleorderButton'
    import GenerateServicedeskButton from '@/components/common/GenerateServicedeskButton'
    import OpenDocumentButton from '@/components/modules/invoices/deadlines/OpenDocumentButton'

    export default {
        name: 'buttons-show-generator',
        components: {
            OpenDocumentButton,
            StartCallButton,
            SignatureDialog,
            PdfPreviewDialog,
            UploadFileButton,
            ConvertLeadComponent,
            GenerateBarcodeDialog,
            TimecardButtonComponent,
            ConvertProspectComponent,
            DuplicateProjectComponent,
            GenerateOpportunityButton,
            GenerateInterventionButton,
            GenerateConfigurationButton,
            ConvertLeadToProspectComponent,
            ConvertOpportunityToProjectComponent,
            GenerateTroubleButtonComponent,
            ProductStockAdjustmentDialog,
            GenerateSubscriptionDialog,
            ConvertToContractsDialog,
            GenerateSaleorderButton,
            GenerateServicedeskButton,
        },
		props: {
            id: Number,
            info: Object,
            model: Object,
		},
		data() {
            return {
                showButtonsList: false,
                confirm: {},
                loading: {},
                multipleEditDialog: false,
                multipleEditModel: {},
                titleDialog: '',
                fieldsset: false,
                saved: false,
			}
        },

        computed: {
            modelDef() {
                return this.info.modelDef
            },

            visibleButtons() {
                const buttons = this.info.buttonShowDefsNew?.visibleActions || [];
                return buttons.filter(button => this.$eventBusUtility.showButton(button));
            },

            dropdownButtons() {
                const buttons = this.info.buttonShowDefsNew?.dropdownActions || [];
                return buttons.filter(button => this.$eventBusUtility.showButton(button));
            },
            
            noDelete() {
                return this.info.noDelete ? this.info.noDelete : false
            },
            
            modelDefRoute() {
                if (this.modelDef.startsWith('documents-')) {
                    return 'documents-edit'
                }
                return this.modelDef + '-edit'
            }
        },

        methods: {
            generateUrl(button) {
                return button.url.replace('{id}', this.id)
            },

            setConfirm(b, value) {
                this.$set(this.confirm, b, value)
                if(!value) {
                    this.setLoading(b, value)
                }
                this.showButtonsList = false
            },

            setLoading(b, value) {
                this.$set(this.loading, b, value)
            },

            createParams(params) {
                let paramsSet = {}
                _.forEach(params, (param ,k) => {
                    if(this.model[k] !== undefined) {
                        paramsSet[param] = this.model[k]
                    }
                    else {
                        paramsSet[param] = k
                    }
                })
                return paramsSet
            },

            callFunction(name) {
                this[name]()
            },

            checkDisabled(button) {
                let result = false

                if(typeof button.disabled != 'undefined') {
                    result = result || !!!this.model[button.disabled]
                }

                if(typeof button.disabled_not != 'undefined') {
                    result = result || !!this.model[button.disabled_not]
                }

                if(typeof button.disabled_advanced != 'undefined') {
                    
                    if(button.disabled_advanced == 'mailmarketing_campaign') {
                        return result || (this.model.campaign_type == 'test' ? false : !!this.model['last_execution'])
                    }

					let value_check = this.model[button.depends_key]
                    // default equal
					if(typeof button.depends_condition === 'undefined'){
						result = result || value_check == button.depends_value
					} else if(button.depends_condition === 'in'){
						result = result || button.depends_value.includes(value_check)
					} else if(button.depends_condition == 'not_equal') {
						result = result || value_check != button.depends_value
					} else if(button.depends_condition == 'empty') {
						result = result || value_check == null || value_check == ''
					} else if(button.depends_condition == 'not_empty') {
						result = result || (value_check != undefined && value_check !== null && value_check !== '')
					}                    
                }

				return result
            },

            deleteModel() {
                this.axios.post(this.modelDef + '/delete', {ids: [this.id]}).then(response => {
                    // get body data
                    const { status, message } = response.data
                    const isWarning = status === 'message' || !!message

                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: isWarning ? message : 'Elementi eliminati con successo.',
                        value: true,
                        color: isWarning ? 'warning' : 'success'
                    })

                    Vue.nextTick(() => {
                        this.setConfirm(99, false)
                    })                    
                    if(status == 'success' || response.status === 204) {
                        this.$router.push({ name: this.modelDef + '-index' })
                    }
                }, response => {
                    // error callback
                })
            },            

            apiActionRedirect(button, b) {
                Vue.nextTick(() => {
                    this.setLoading(b, true)
                })
                this.axios.get(button.url + '/' + this.id).then(response => {
                    Vue.nextTick(() => {
                        this.setConfirm(b, false)
                    })
                    // get body data
                    if(typeof button.route != 'undefined') {
                        this.$eventBusUtility.goTo(
                            this.$router, 
                            button.route, 
                            response.data[button.id_key || 'id'],
                            null,
                            button.params ? button.params : null
                        )
                    } else {
                        this.$store.commit('setSnackbar', {
                            timeout: 6000,
                            text: response.data.message,
                            value: true,
                            color: 'success'
                        })
                        this.$eventBusUtility.$emit('refreshShow')
                    }

                }, response => {
                    // error callback
                })
            },

			multipleEdit(button) {
                this.titleDialog = button.tooltip
				this.axios.get(this.modelDef + '/create', {params: {'field_filters':{'multiple_edit': true}}}).then(response => {

					this.fieldsset = response.data.fields
					this.multipleEditDialog = true
					// remove validations rule
                    this.fieldsset.fields.map((field) => {
                        delete field.required
                        delete field.validations
                        return field
                    })

				}, response => {
					// error callback
				})
			},

			closeDialog() {
                this.multipleEditDialog = false
				this.multipleEditModel = {}
                this.saved = false
			},

			saveModel(b) {
                this.saved = true
                this.axios.post('multiple/' + this.modelDef, {'model': this.multipleEditModel, 'ids': [this.id]}).then(response => {
                    // get body data
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: response?.data?.message || 'Aggiornato con successo',
                        value: true,
                        color: 'success'
                    })
                    this.$eventBusUtility.$emit('refreshShow')
                    this.closeDialog()

                }, response => {
                    // error callback
                    this.saved = false
                })
			},
        },

        mounted() {
            this.$eventBusUtility.$on('showButtonsList', (showButtonsList) => this.showButtonsList = showButtonsList)
        },
	}
</script>

